var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"formFilter",staticClass:"olb-form-filter"},[(!_vm.disabled)?_c('input',{staticClass:"olb-input mb-7",attrs:{"type":"text","placeholder":_vm.inputPlaceholder},on:{"input":_vm.onInput}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }